import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { BlueBorderButton, BlueButton } from 'components/Button';
import Modal, { ModalHeader, ModalMessage } from 'components/Modal';
import Break from 'components/Break';

import { convertTohhmmss, convertToSeconds } from 'utils/format';
import HourMinuteSecondInput from 'components/HourMinuteSecondInput';
import { openErrorModal } from 'reducers/modal/actions';
import {
  setConfigurationOptions,
  updateConfigurationOptions
} from 'reducers/device/actions';
import { useDispatch } from 'react-redux';

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  height: 33px;
  margin: ${({ margin }) => (margin ? margin : '1em 0')};
`;

const InputLabel = styled(ModalMessage)`
  flex: 1 1 40%;
  font-size: 12px;
  line-height: 16px;
`;

const ButtonRow = styled.div``;

const EditConfigurationModal = ({ closeModal, rowData }) => {
  const dispatch = useDispatch();
  const [inputValues, setInputValues] = useState({
    edevListPollRate: {},
    mupListPollRate: {}
  });
  const [errorValues, setErrorValues] = useState({
    edevListPollRate: null,
    mupListPollRate: null
  });

  useEffect(() => {
    const newInputValues = {};
    rowData.forEach(
      row => (newInputValues[row.id] = convertTohhmmss(row.value))
    );
    setInputValues(newInputValues);
  }, [rowData]);

  const handleSubmit = async e => {
    e.preventDefault();
    //Validation
    const requestBody = {};

    let passed = true;

    //edevListPollRate validation
    const parsedAsIntEdevListPollRateInputHours = parseInt(
      inputValues.edevListPollRate.hours
    );
    const parsedAsIntEdevListPollRateInputMinutes = parseInt(
      inputValues.edevListPollRate.minutes
    );
    const parsedAsIntEdevListPollRateInputSeconds = parseInt(
      inputValues.edevListPollRate.seconds
    );
    const convertedEdevListPollRate = convertToSeconds({
      hours: parsedAsIntEdevListPollRateInputHours,
      minutes: parsedAsIntEdevListPollRateInputMinutes,
      seconds: parsedAsIntEdevListPollRateInputSeconds
    });

    if (
      Number.isInteger(parsedAsIntEdevListPollRateInputHours) ||
      Number.isInteger(parsedAsIntEdevListPollRateInputMinutes) ||
      Number.isInteger(parsedAsIntEdevListPollRateInputSeconds)
    ) {
      if (
        Number.isNaN(convertedEdevListPollRate) ||
        convertedEdevListPollRate < 0 ||
        convertedEdevListPollRate > 4294967295
      ) {
        passed = false;
        setErrorValues(prevErrorValues => ({
          ...prevErrorValues,
          edevListPollRate: true
        }));
      } else {
        requestBody.edevListPollRate = convertedEdevListPollRate;
      }
    }

    //mupListPollRate validation
    const parsedAsIntMupListPollRateInputHours = parseInt(
      inputValues.mupListPollRate.hours
    );
    const parsedAsIntMupListPollRateInputMinutes = parseInt(
      inputValues.mupListPollRate.minutes
    );
    const parsedAsIntMupListPollRateInputSeconds = parseInt(
      inputValues.mupListPollRate.seconds
    );
    const convertedMupListPollRate = convertToSeconds({
      hours: parsedAsIntMupListPollRateInputHours,
      minutes: parsedAsIntMupListPollRateInputMinutes,
      seconds: parsedAsIntMupListPollRateInputSeconds
    });
    if (
      Number.isInteger(parsedAsIntMupListPollRateInputHours) ||
      Number.isInteger(parsedAsIntMupListPollRateInputMinutes) ||
      Number.isInteger(parsedAsIntMupListPollRateInputSeconds)
    ) {
      if (
        Number.isNaN(convertedMupListPollRate) ||
        convertedMupListPollRate < 0 ||
        convertedMupListPollRate > 4294967295
      ) {
        passed = false;
        setErrorValues(prevErrorValues => ({
          ...prevErrorValues,
          mupListPollRate: true
        }));
      } else {
        requestBody.mupListPollRate = convertedMupListPollRate;
      }
    }

    if (passed !== true) {
      openErrorModal('Input was out of range.');
      console.error('Input was out of range.');
      return;
    } else {
      await dispatch(setConfigurationOptions(requestBody, true));
      //TODO: Take this updateConfigurationOptions() out. This is a temporary fix while setConfigurationOptions()
      //returns the wrong data.
      await dispatch(updateConfigurationOptions());
      closeModal();
    }
  };

  return (
    <Modal
      as="form"
      style={{
        padding: '2em 3em',
        minWidth: '575px',
        minHeight: '250px',
        boxSizing: 'border-box'
      }}
      onSubmit={handleSubmit}
    >
      <ModalHeader>Edit Configuration Details</ModalHeader>

      {rowData.map(row => {
        return (
          <InfoRow key={row.id}>
            <InputLabel>{row.description}</InputLabel>
            <HourMinuteSecondInput
              fieldId={row.id}
              values={inputValues[row.id]}
              errors={errorValues[row.id]}
              setValues={setInputValues}
            />
          </InfoRow>
        );
      })}

      <Break margin="2em 0" />

      <ButtonRow>
        <BlueBorderButton
          margin="0 16px 0 0"
          type="button"
          onClick={closeModal}
        >
          Close
        </BlueBorderButton>
        <BlueButton type="submit">Save Changes</BlueButton>
      </ButtonRow>
    </Modal>
  );
};

export default EditConfigurationModal;
